import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbGetRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getDataManagerProvisioningStatusUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getDataManagerProvisioningStatusUrl.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type {
	ActionApi,
	ProvisioningStatus,
	ProvisioningStatusResponse,
} from './ActionApi.types.tsx';

export const fetchProvisioningStatus =
	(shouldRefetch = true): ActionApi =>
	async ({ setState, getState }, { workspaceId, createAnalyticsEvent }) => {
		if (
			getState().dataManager.provisioningLoading ||
			(!shouldRefetch &&
				// isProvisioned is a boolean so needs to specifically check undefined
				getState().dataManager.isProvisioned !== undefined)
		) {
			return;
		}
		setState({
			dataManager: {
				...getState().dataManager,
				provisioningLoading: true,
				provisioningError: undefined,
			},
		});

		try {
			const result: ProvisioningStatusResponse = await performCmdbGetRequest(
				getDataManagerProvisioningStatusUrl(workspaceId),
			);

			setState({
				dataManager: {
					...getState().dataManager,
					isProvisioned: isProvisioned(result.enabled),
					provisioningLoading: false,
				},
			});
			fireTrackAnalytics(createAnalyticsEvent({}), 'fetchProvisioningStatus succeeded');
		} catch (error: unknown) {
			const normalizedError = error instanceof Error ? error : new Error(String(error));
			setState({
				dataManager: {
					...getState().dataManager,
					provisioningLoading: false,
					provisioningError: normalizedError,
				},
			});
			fireCmdbErrorAnalytics({
				meta: {
					id: 'fetchProvisioningStatus',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'aurum',
				},
				error: normalizedError,
			});

			throw error;
		}
	};

const isProvisioned = (status: ProvisioningStatus) => status === 'ON';
